// extracted by mini-css-extract-plugin
export default {"chat-details-container":"chat-details_chat-details-container__pwqs-"};